(function() {
    const box = document.getElementById('main-content');

    let isMobile = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || window.innerWidth <= 1000;

    function getNodeList(node) {

        var list = Array.prototype.slice.call(node.querySelectorAll('[node-name]'), 0);
        var nodeList = {};

        list.forEach(function(el) {
            var name = el.getAttribute('node-name');

            if (name in nodeList) {
                nodeList[name] = [].concat(nodeList[name], el);
            } else {
                nodeList[name] = el;
            }
        });

        return nodeList;
    }

    function getOffset(el) {
        let box = el.getBoundingClientRect();
        let body = document.body;
        let clientTop = el.clientTop || body.clientTop || 0;
        let clientLeft = el.clientLeft || body.clientLeft || 0;
        let scrollTop = window.scrollY || el.scrollTop;
        let scrollLeft = window.scrollX || el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft,
            scrollTop,
            scrollLeft
        };
    }

    let screenHeight = window.innerHeight;
    let nodeList = getNodeList(box);
    console.log(nodeList);

    if (!nodeList.fifthMenu) {
        return false;
    }

    let offsetMap = {};

    document.addEventListener('scroll', function() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        runFiveAnime(scrollTop);
        runThirteenAnime(scrollTop);
        runFourteenAnime(scrollTop);
        playVideo(scrollTop);
    }, { passive: true });

    let _timer = null;
    window.addEventListener('resize', function() {
        clearTimeout(_timer);
        _timer = setTimeout(() => {
            initOffset();
            isMobile = /android|iphone|ipad|ipod|micromessenger/gi.test(navigator.userAgent.toLocaleLowerCase()) || window.innerWidth <= 1000;
        }, 100);
    });

    // 初始化偏移量
    function initOffset() {
        offsetMap.five = {
            menus: nodeList.fifthMenus,
            menu: nodeList.fifthMenu,
            slide: nodeList.fifthSlide,
            top: getOffset(nodeList.fifthPage).top,
            height: nodeList.fifthPage.offsetHeight
        };

        offsetMap.thirteen = {
            wordNode: nodeList.thirteenthWord,
            imgNode: nodeList.thirteenthImg,
            top: getOffset(nodeList.thirteenthPage).top,
            height: nodeList.thirteenthPage.offsetHeight
        };

        offsetMap.fourteen = {
            node: nodeList.fourteenBox,
            top: getOffset(nodeList.fourteenPage).top,
            height: nodeList.fourteenPage.offsetHeight
        };

        const videoList = [];
        const list = isMobile ? nodeList.mobileVideo : nodeList.pcVideo;
        list.forEach(node => {
            videoList.push({
                node,
                play: false,
                top: getOffset(node).top
            });
        });

        videoList.push({
            play: false,
            node: nodeList.video,
            top: getOffset(nodeList.video).top
        });

        offsetMap.videoList = videoList;
    }

    // 播放视频
    function playVideo(scrollTop) {
        const list = offsetMap.videoList;
        if (list && list.length > 0) {
            list.forEach(obj => {
                if (!obj.play && scrollTop + 200 > obj.top) {
                    obj.node.play();
                    obj.play = true;
                }
            });
        }
    }

    initOffset();

    // 获取滑动比例
    function getMoveRate(scrollTop, top, height) {
        return Math.round(Math.min(1, Math.max(0, scrollTop - top) / (height - screenHeight)) * 100);
    }

    // 第五屏动画
    let fiveSelect = 0;

    nodeList.fifthMenus.addEventListener('click', ev => {
        const height = offsetMap.five.height;
        const top = offsetMap.five.top;
        const mod = height / 7;
        const index = ev.target.dataset.key;
        console.log(ev.target, index);
        if (index) {
            window.scrollTo(0, top + mod * index - (index > 0 ? 10 : 0));
        }
    });

    function runFiveAnime(scrollTop) {
        if (!offsetMap.five) {
            return false;
        }
        const obj = offsetMap.five;
        const rate = getMoveRate(scrollTop, obj.top, obj.height);
        let select = 0;
        if (rate < 14) {
            select = 0;
        } else if (rate < 28) {
            select = 1;
        } else if (rate < 42) {
            select = 2;
        } else if (rate < 56) {
            select = 3;
        } else if (rate < 70) {
            select = 4;
        } else if (rate < 84) {
            select = 5;
        } else {
            select = 6;
        }

        if (fiveSelect !== select) {
            obj.menu[fiveSelect].classList.remove('selected');
            obj.menu[select].classList.add('selected');
            obj.slide[fiveSelect].classList.remove('show');
            obj.slide[select].classList.add('show');
            fiveSelect = select;
        }
    }

    // 第十三屏动画
    let thirteenSelect = 0;

    function runThirteenAnime(scrollTop) {
        if (!offsetMap.thirteen || isMobile) {
            return false;
        }
        const obj = offsetMap.thirteen;
        const rate = getMoveRate(scrollTop, obj.top, obj.height);
        let select = 0;
        if (rate < 50) {
            select = 0;
        } else {
            select = 1;
        }

        if (thirteenSelect !== select) {
            obj.imgNode[thirteenSelect].classList.remove('show');
            obj.imgNode[select].classList.add('show');
            obj.wordNode[thirteenSelect].classList.remove('show');
            obj.wordNode[select].classList.add('show');
            thirteenSelect = select;
        }
    }

    // 第十四屏动画
    let fourteenSelect = 0;

    function runFourteenAnime(scrollTop) {
        if (!offsetMap.fourteen || isMobile) {
            return false;
        }
        const obj = offsetMap.fourteen;
        const rate = getMoveRate(scrollTop, obj.top, obj.height);
        let select = 0;
        if (rate < 50) {
            select = 0;
        } else {
            select = 1;
        }

        if (fourteenSelect !== select) {
            if (select === 0) {
                obj.node.classList.remove('show');
            } else {
                obj.node.classList.add('show');
            }
            fourteenSelect = select;
        }
    }
})();
